import React from 'react';
import {UncontrolledTooltip} from 'reactstrap';

import {useLimits} from 'contexts/LimitsContext';
import {getFormattedNumber} from 'utils/numbers';
import {LoadingText} from 'components/Loading';
import {useMembership} from 'contexts/MembershipContext';
import MuiIcon from 'components/Icons/MuiIcon';

function PrivateNavLimit() {
  const {isLegacyUser} = useMembership();
  const {data, isLoading} = useLimits();

  const {available_limit_left, company_available_limit_left} = data;

  const limitLeft = isLegacyUser
    ? available_limit_left
    : company_available_limit_left;

  return (
    <div className="mr-3 d-none d-xl-block">
      <span className="text-dark font-weight-bold mr-1">
        {isLegacyUser ? 'Available Credits' : 'Credits'}:{' '}
        {isLoading ? <LoadingText isLoading /> : getFormattedNumber(limitLeft)}
      </span>
      <MuiIcon name="info" color="dark" id="limit-tooltip" />

      <UncontrolledTooltip fade={false} target="limit-tooltip">
        <small>
          {isLegacyUser
            ? 'Refers to the remaining credits available for consumption within your current plan.'
            : '1 company = 1 credit'}
        </small>
      </UncontrolledTooltip>
    </div>
  );
}

export default PrivateNavLimit;
